
import { defineComponent, PropType } from 'vue';
import { QuestionAnswerState } from '@/vuex/AnswerStore';
import { GqlAllMyReports } from '@/gql/AllMyReports';
import InspectCountry from '@/components/Forms/QuestionType/Country.vue';

export default defineComponent({
  props: {
    value: { type: Object },
    qa: { type: Object as PropType<QuestionAnswerState> },
    report: { type: Object as PropType<GqlAllMyReports> },
  },
  components: {
    InspectCountry,
  },
  methods: {
    updateValue(e) {
      this.$emit('updateValue', [e[0], e[1]]);
    },
  },
});
